import { IResourceComponentsProps, useExport } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Divider,
  Input,
  Button,
  useTable,
  Form
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'
import { IStrand } from 'interfaces'
import { CreateStrand } from './create'
import { EditStrand } from './edit'
import { useState } from 'react'
import { exportToExcel } from 'exportToExcel'
const { PlusOutlined } = Icons

export const StrandList: React.FC<IResourceComponentsProps> = () => {
  const [pagination,setHasPagination]=useState<any>(true)
  const { tableProps,searchFormProps, tableQueryResult ,setFilters,sorter} = useTable<IStrand>({
    hasPagination:pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter:[
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: [
        'id',
        'name',
        'competency_id',
        { competency: ['name'] },
        'taxonomy_id',
        { taxonomy: ['name'] },
        'teacher_level_id',
        { teacher_level: ['name'] },
        'created_at',
        { questions: ['id'] },
        { work_requests: ['id'] },
      ],
    },
    onSearch: (values:any) => {
      return [
          {
              field: "name",
              operator: "contains",
              value:`%${values.title}%`,
          },
      ];
  },
  })
  const {  tableQueryResult :exportData} = useTable<IStrand>({
    hasPagination:false,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: [
        'id',
        'name',
        'competency_id',
        { competency: ['name'] },
        'taxonomy_id',
        { taxonomy: ['name'] },
        'teacher_level_id',
        { teacher_level: ['name'] },
        'created_at',
        { questions: ['id'] },
        { work_requests: ['id'] },
      ],
    },
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'strands',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'strands',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'competency_id', 'taxonomy_id', 'teacher_level_id', 'description', 'created_at'],
    },
  })

  const hideDeleteButton = (record: IStrand): boolean => {
    const { questions: q, work_requests: wr } = record
    if (q !== undefined && wr !== undefined) {
      const shouldHide = q.length > 0 || wr.length > 0
      return shouldHide
    }
    return false
  }

  // const { triggerExport, isLoading } = useExport<IStrand>()
  
  const triggerExport=()=>{
    // setHasPagination(false)
    let data:object[]=[]
    if(exportData !==undefined){
      exportData?.data?.data?.forEach((item:IStrand)=>{
  data?.push({
    id:item?.id,
    name:item?.name,
    competency:item?.competency?.name,
    taxonomy:item?.taxonomy?.name,
    teacher_level:item?.teacher_level?.name
  })
})
    }
    exportToExcel(data,`Standards_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }
  return (
    <List
      title="Standard"
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
          <Button onClick={triggerExport}>Export</Button>
        ],
      }}
    >
       <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              searchFormProps.form?.submit()
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>
    <Divider/>
      <Table {...tableProps} >
    
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column<IStrand> dataIndex="teacher_level_id" render={(_, record) => record?.teacher_level?.name} title="Teacher Level" />
        <Table.Column<IStrand> dataIndex="taxonomy_id" render={(_, record) => record?.taxonomy?.name} title="Taxonomy" />
        <Table.Column<IStrand> dataIndex="competency_id" render={(_, record) => record?.competency?.name} title="Competency" />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<IStrand>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} hidden={hideDeleteButton(record)} />
            </Space>
          )}
        />
      </Table>
      <CreateStrand modalProps={modalProps} formProps={formProps} />
      <EditStrand modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
